'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    margin: '0 auto',
    border: '2px solid'
  }
};

function Button(_ref) {
  var href = _ref.href,
      type = _ref.type,
      children = _ref.children,
      _onClick = _ref.onClick,
      width = _ref.width,
      height = _ref.height,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      borderColor = _ref.borderColor,
      hoverBackgroundColor = _ref.hoverBackgroundColor,
      hoverColor = _ref.hoverColor,
      hoverBorderColor = _ref.hoverBorderColor,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      textTransform = _ref.textTransform,
      disabled = _ref.disabled,
      customStyles = _ref.customStyles;
  var Element = href ? "a" : "div";
  var role = type ? type : "button";
  var style = [dimension(), colors(), font(), styles.button, customStyles];

  function dimension() {
    return {
      width: width || 'auto',
      height: height || 'auto'
    };
  }

  function colors() {
    return {
      backgroundColor: backgroundColor || 'initial',
      color: color || 'initial',
      borderColor: borderColor || 'initial',
      ':hover': {
        backgroundColor: hoverBackgroundColor || backgroundColor,
        color: hoverColor || color,
        borderColor: hoverBorderColor || borderColor
      }
    };
  }

  function font() {
    return {
      fontFamily: fontFamily || '"Gotham SSm A", "Gotham SSm B"',
      fontSize: fontSize || '16px',
      fontWeight: fontWeight || 400,
      textTransform: textTransform || 'uppercase'
    };
  }

  function handleClick(e, onClick) {
    if (onClick) {
      onClick();
    }
  }

  return _react2["default"].createElement(Element, {
    className: 'Button',
    style: style,
    type: type,
    href: href,
    onClick: function onClick(e) {
      return handleClick(e, _onClick);
    },
    disabled: disabled,
    tabIndex: '0'
  }, children);
}

var component = (0, _radium2["default"])(Button);
exports["default"] = {
  component: component
};